import styled from "@emotion/styled";
import {
  Box,
  Button,
  FormHelperText,
  InputLabel,
  Link,
  OutlinedInput,
  Typography,
} from "@mui/material";

export const FormContainer = styled(Box)`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  @media (max-width: 375px) {
    align-items: flex-start;
  }
`;

export const DescriptionContainer = styled(Box)`
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 375px;
  gap: 24px;

  @media (max-width: 375px) {
    padding: 48px 0px 48px 0px;
  }
`;

export const FormText = styled(Typography)``;

export const PrivacyText = styled(Typography)`
  text-align: center;
`;

export const PrivacyTextLink = styled(Link)`
  color: #000;
`;

export const FormTitle = styled(Typography)`
  margin-bottom: 8px;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  height: 52px;
  margin-top: 16px;
  text-transform: none;
`;

export const FromInput = styled(OutlinedInput)`
  height: 52px;
`;

export const FormInputLabel = styled(InputLabel)`
  font-size: 16px;
`;

export const FormErrorText = styled(FormHelperText)`
  text-align: center;
`;
